var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50094)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86034e-08 8.11719C4.86034e-08 9.08798 0.787021 9.875 1.75781 9.875H6.44531C7.4161 9.875 8.20312 9.08798 8.20312 8.11719V2.25781C8.20312 1.28702 7.4161 0.5 6.44531 0.5H1.75781C0.787021 0.5 4.86034e-08 1.28702 4.86034e-08 2.25781V8.11719ZM1.75781 8.70312C1.43423 8.70312 1.17187 8.44077 1.17187 8.11719V2.25781C1.17187 1.93423 1.43423 1.67188 1.75781 1.67188H6.44531C6.7689 1.67188 7.03125 1.93423 7.03125 2.25781V8.11719C7.03125 8.44077 6.7689 8.70312 6.44531 8.70312H1.75781Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34375 7.53125H3.51562V6.35938H4.10156C5.07235 6.35938 5.85937 5.57235 5.85937 4.60156C5.85937 3.63077 5.07235 2.84375 4.10156 2.84375H2.34375V7.53125ZM3.51562 5.1875V4.01562H4.10156C4.42515 4.01562 4.6875 4.27798 4.6875 4.60156C4.6875 4.92515 4.42515 5.1875 4.10156 5.1875H3.51562Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 19.9141V9.28906H3.51562V19.9141H4.6875Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19.3281H0V20.5H20V19.3281Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9375 18.1562H20V15.2266C20 14.2558 19.213 13.4687 18.2422 13.4687H7.69531C6.72452 13.4687 5.9375 14.2558 5.9375 15.2266V18.1562ZM7.10937 16.9844V15.2266C7.10937 14.903 7.37173 14.6406 7.69531 14.6406H18.2422C18.5658 14.6406 18.8281 14.903 18.8281 15.2266V16.9844H7.10937Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7981 13.8694L17.8933 11.1551C17.654 10.4373 16.9823 9.95312 16.2257 9.95312H9.71183C8.95521 9.95312 8.2835 10.4373 8.04422 11.155L7.13944 13.8694L8.25118 14.24L9.15594 11.5257C9.15593 11.5257 9.15594 11.5257 9.15594 11.5257C9.23572 11.2864 9.45964 11.125 9.71183 11.125H16.2257C16.4779 11.125 16.7018 11.2864 16.7816 11.5256C16.7815 11.5256 16.7816 11.5256 16.7816 11.5256L17.6863 14.24L18.7981 13.8694Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 19.9141V17.5703H9.45312V19.9141H10.625Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10937 17.5703V19.9141H8.28125V17.5703H7.10937Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8281 19.9141V17.5703H17.6562V19.9141H18.8281Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3125 17.5703V19.9141H16.4844V17.5703H15.3125Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.c15a75f15373f43cd831b0516eb6183b.svg";
export { ForwardRef as ReactComponent };